import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Components
import GroupNameButton from './components/GroupNameButton';
import EventsTimelineCell from './components/EventsTimelineCell';
import { selectDatesOfTheWeek } from '../../selectors';

interface Props {
    groupId?: ?number;
    datesOfTheWeek: string[];
}

export class EventsTimelineRow extends React.PureComponent<Props> {
    render() {
        const { groupId, datesOfTheWeek } = this.props;
        return (
            <Table.Row
                // HACK: inline style
                style={{
                    height: 140
                    // TODO: Implement compact view
                    // height: 75
                }}
            >
                <Table.Cell
                    // HACK: inline style
                    style={{
                        padding: 0,
                        textAlign: 'center'
                    }}
                >
                    <GroupNameButton groupId={groupId} />
                </Table.Cell>
                {datesOfTheWeek.map(date => (
                    <EventsTimelineCell
                        key={`${date}-${groupId}`}
                        groupId={groupId}
                        date={date}
                    />
                ))}
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    datesOfTheWeek: selectDatesOfTheWeek
});

export default connect(mapStateToProps)(EventsTimelineRow);
